import { Link } from "react-router-dom";
import { companyInfo, services } from "@/data/mock";
import {
  Phone,
  Mail,
  MapPin,
  Facebook,
  Instagram,
  Linkedin,
  ArrowUpRight,
} from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-onix-darker border-t border-cyan-900/20">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={companyInfo.logo}
                alt="Grupo Onix"
                className="h-12 w-12 object-contain"
              />
              <span className="text-lg font-orbitron font-bold text-white tracking-wider">
                GRUPO <span className="text-cyan-400">ONIX</span>
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              {companyInfo.tagline}. Soluciones integrales en redes, seguridad y
              energía solar.
            </p>
            <div className="flex gap-3">
              {[
                { icon: Facebook, href: companyInfo.social.facebook },
                { icon: Instagram, href: companyInfo.social.instagram },
                { icon: Linkedin, href: companyInfo.social.linkedin },
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-slate-400 hover:text-cyan-400 hover:border-cyan-500/30 hover:bg-cyan-500/10 transition-all duration-300"
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">
              Navegación
            </h4>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Inicio" },
                { to: "/acerca", label: "Acerca de" },
                { to: "/servicios", label: "Servicios" },
                { to: "/contacto", label: "Contacto" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-slate-400 text-sm hover:text-cyan-400 transition-colors flex items-center gap-1 group"
                  >
                    {link.label}
                    <ArrowUpRight
                      size={12}
                      className="opacity-0 group-hover:opacity-100 transition-opacity"
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">
              Servicios
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.id}>
                  <Link
                    to="/servicios"
                    className="text-slate-400 text-sm hover:text-cyan-400 transition-colors flex items-center gap-1 group"
                  >
                    {service.title}
                    <ArrowUpRight
                      size={12}
                      className="opacity-0 group-hover:opacity-100 transition-opacity"
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">
              Contacto
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-start gap-3 text-slate-400 text-sm hover:text-cyan-400 transition-colors"
                >
                  <Phone size={16} className="mt-0.5 shrink-0" />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-start gap-3 text-slate-400 text-sm hover:text-cyan-400 transition-colors"
                >
                  <Mail size={16} className="mt-0.5 shrink-0" />
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <MapPin size={16} className="mt-0.5 shrink-0" />
                {companyInfo.address}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Grupo Onix. Todos los derechos
            reservados.
          </p>
          <p className="text-slate-600 text-xs hover:text-cyan-400 transition-colors">
            Desarollado por{" "}
            <a href="https://jupitersoft.tech/">JupiterSoftTech</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
